import {Button} from '@primer/react'
import {CommentIcon} from '@primer/octicons-react'
import type {IssueCommentInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {DockedPanel, useDockedPanelActions} from '../../../../contexts/DockedPanelContext'

export function IssueCommentAction({info}: {info: IssueCommentInfo}) {
  const dockedPanelActions = useDockedPanelActions()
  const commentId = info.commentId

  if (!commentId) {
    return null
  }
  return (
    <Button
      onClick={() =>
        dockedPanelActions.openPanel(DockedPanel.Comments, {
          metadata: {filterText: `comment-id:${commentId}`, viewMode: 'issue-comments'},
        })
      }
      size="small"
      variant="invisible"
      aria-label={`View issue comment`}
      icon={CommentIcon}
      className="flex-items-center"
    />
  )
}
